import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
  name: 'distance',
  standalone: false,
})
export class DistancePipe implements PipeTransform {
  transform(distanceM?: number): number {
    const distanceKm = distanceM ? distanceM / 1000 : null
    return distanceKm
  }
}
